import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { RecruiterData } from "@/hooks/dashboard/useDashboardKPIs";
import { KPITooltip } from "./KPITooltip";

interface RecruiterTableProps {
	data: RecruiterData[];
	tooltip?: string;
}

export function RecruiterTable({ data, tooltip }: RecruiterTableProps) {
	const { t } = useTranslation();

	return (
		<Card>
			<CardHeader className={data.length === 0 ? "pb-2" : undefined}>
				<div className="flex items-center gap-2">
					<CardTitle className="text-lg">{t("dashboard.kpi.recruiterProductivity")}</CardTitle>
					{tooltip && <KPITooltip text={tooltip} />}
				</div>
			</CardHeader>
			<CardContent>
				{data.length === 0 ? (
					<div className="text-muted-foreground text-sm py-2">
						{t("dashboard.kpi.noData")}
					</div>
				) : (
					<div className="overflow-x-auto">
						<table className="w-full text-sm">
							<thead>
								<tr className="border-b">
									<th className="text-left py-2 px-2 font-medium text-muted-foreground">
										{t("dashboard.kpi.recruiterName")}
									</th>
									<th className="text-right py-2 px-2 font-medium text-muted-foreground">
										{t("dashboard.kpi.openJobsCount")}
									</th>
									<th className="text-right py-2 px-2 font-medium text-muted-foreground">
										{t("dashboard.kpi.matchesCreated", "Matches Created")}
									</th>
									<th className="text-right py-2 px-2 font-medium text-muted-foreground">
										{t("dashboard.kpi.hiresCount")}
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((recruiter) => (
									<tr key={recruiter.id} className="border-b last:border-0">
										<td className="py-2 px-2">{recruiter.name}</td>
										<td className="text-right py-2 px-2">{recruiter.openJobs}</td>
										<td className="text-right py-2 px-2 text-blue-500 font-medium">{recruiter.matchesCreated}</td>
										<td className="text-right py-2 px-2 font-medium">{recruiter.hires}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</CardContent>
		</Card>
	);
}
